import { useGlobalAppStore } from "../context/store/useGlobalAppStore";

export type ProbeService =
  | "oms"
  | "pg"
  | "kyc_verification"
  | "bank_account_verification"
  | "warehouse";

type Props = {
  requiredProbeServices: ProbeService[];
  children: React.ReactNode;
};

function RenderByProbeServiceConfig({ requiredProbeServices, children }: Readonly<Props>) {
  const { probeConfig } = useGlobalAppStore();

  if (!probeConfig) {
    return null;
  }

  const allServicesEnabled = requiredProbeServices.every(
    (service) => probeConfig?.[service] === true
  );

  return allServicesEnabled ? children : null;
}

export default RenderByProbeServiceConfig;
